import Vue from "vue";

Vue.directive("slide-content",
    {
        bind(el, binding)
        {
            el.addEventListener("click", () =>
            {
                vueApp.$root.$emit("toggle-aside", binding.value);
            });
        },
        unbind(el)
        {
            el.removeEventListener("click", () =>
            {
                vueApp.$root.$emit("toggle-aside", binding.value);
            });
        }
    }
);
